import axiosInstance from '../mainService';

const custService = {
    getCust(period, search,page, limit) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/get-score/${period}/${sanitizedSearch}/${page}/${limit}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    async fetchQuestion() {
        const response = await axiosInstance.get(`/get-rate/id`);
        return response.data;
    },
    totalAllCust(search) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/t108_rate/name_c_feedback/${sanitizedSearch}`);
    },
    deleteCust(custId) {
        return axiosInstance.delete(`/delete-data/t108_rate/${custId}`);
    },
    addCust(cust) {
        return axiosInstance.post('/insert-rate', cust);
    },
    updateCust(cust) {
        return axiosInstance.put(`/update-data/t108_rate/${cust.id}`, cust);
    },
    downloadRateList(periode){
        return axiosInstance.get('/download-data-rate/' + periode);
    }
};

export default custService;